import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import useDimensions from 'react-cool-dimensions';
import mergeClassNames from '../../modules/lower-ui-kit/lib/style-helpers/merge-class-name';
import { FontSize, FontType } from '../../config/theme/types/themeTypes';
import AppDimensionsProvider from '../../hooks/useAppDimensions/useAppDimensions.provider';

interface PageProps {
  fullWidth?: boolean;
  background?: boolean;
  className?: string;
}

function Scene({
  children,
  className,
  fullWidth = false,
  background = false,
  ...props
}: React.PropsWithChildren<PageProps>) {
  const {
    ref, width, height,
  } = useDimensions<HTMLDivElement>({
    breakpoints: {
      LG: 799,
      SM: 0,
    },
  });

  const isMobile = width < 799;

  return (
    <Container ref={ref}>
      <AppDimensionsProvider
        width={width}
        height={height}
        isMobile={isMobile}
      >
        <ContentWrapper
          className={mergeClassNames(
            'Scene',
            fullWidth && '--full-width',
            className,
            background && '--background',
          )}
          {...props}
        >
          {
            children && children
          }
        </ContentWrapper>
      </AppDimensionsProvider>
    </Container>
  );
}

const Container = styled(motion.div)`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  flex-wrap:nowrap;

  white-space: pre-wrap;

  ${({ theme }) => `
    color: ${theme.colors.text};
    ${theme.font(FontType.Regular, FontSize.Medium)}
  `}
`;

const ContentWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 810px;
  height: 100%;
  padding: 12px;
  &.--full-width {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }
  &.--background{
    background-color: ${({ theme }) => theme.uploadPage.sceneBackgroundColor};
  }
`;

export default Scene;
